import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=4033ff12&scoped=true&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"
import style0 from "./excel.vue?vue&type=style&index=0&id=4033ff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4033ff12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4033ff12')) {
      api.createRecord('4033ff12', component.options)
    } else {
      api.reload('4033ff12', component.options)
    }
    module.hot.accept("./excel.vue?vue&type=template&id=4033ff12&scoped=true&", function () {
      api.rerender('4033ff12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/return/components/import/excel.vue"
export default component.exports